import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Image,
    View,
    TouchableOpacity,
    ScrollView,
    FlatList,
    Animated,
    Dimensions,
    Platform
} from 'react-native';

import {
    JDText,
    JDImage,
    JDConfirmDialog,
    JDPopupWindow,
    JDTouchable,
    JDShare,
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';
import {
    // Unreal,
    utils
} from '@ltfe/ltfe-core-lib';
import HotTop from '../components/index/hot-top';
import HotTopBook from '../components/index/hot-top-book';
import CinemaItem from '../components/common/cinema-item';
import SeeTomorrow from '../components/movieSchedule/see-tomorrow';
import PreWantMovieItem from '../components/common/pre-want-movieItem';
import BookShowItem from '../components/index/book-show-item';
import Nav from '../components/common/nav';
import Loading from '../components/common/loading';
import WifiOut from '../components/common/wifi-out';
import OpeningHint from '../components/common/opening-hint';
import SpecialPrice from '../components/specialPrice/special-price';
import CityScreening from '../components/common/cityScreening';
import DownLayer from '../components/common/cityScreening/downLayer';
import GradientNavBar from '../components/gradient-nav-bar';
import LoadingAnimation from '../components/index/loading-animation';
import WebSwiper from '../components/swiper/swiper';
import { mta, mtaPV, isNetWork, LBSbusinessId, sceneId, fetchSession, fetchLocal, saveSession, getCookie, isWeb } from '../common/utils';
import { get } from '../common/fetch';

import netImg from '../common/netImg';

import img from '../common/img';
import st from '../style/index.st';
import {
    getWebLocation,
    withLocation
} from '../common/getWebLbs';
import sgmReport from '../common/sgmUtil';


// 解决转web后的兼容行问题：今日特价弹框弹框谈起时，搜索框层级大于弹框
require('../style/index.css');

const { getLBS, iphoneXMarginBottom, pt } = utils;

class Index extends PureComponent {
    constructor(props) {
        super(props);
        this.refCouponList = null;
        this.state = {
            progress: new Animated.Value(0),
            navType: 0,
            curType: +props.curType || 1,
            loading: true,
            wifiOut: false,
            showType: [
                { name: '正在热映', type: 1 },
                { name: '即将上映', type: 2 },
                { name: '预约放映', type: 3 }
            ],
            test: [],
            hotMovie: [],
            mostExpectList: [],
            // 定位失败提示
            dialog: false,
            // 切换城市提示
            lbsDialog: false,
            cinemaList: null,
            totalNum: 0,
            pageNum: 1,
            pageSize: 20,
            queryDate: '',
            willMovieList: [],
            scheduledBannerUrl: '', // 预约放映bannerUrl
            scheduledBannerDetailUrl: '', // 预约放映bannerDetailUrl 跳转到通天塔
            scheduledMovieList: [], // 预约放映列表
            scheduledTotalNum: 0, // 预约放映影片列表接口返回的总数量
            scheduledPageNum: 1, // 预约放映影片列表接口返回的总数量
            scheduledPageSize: 20, // 预约放映影片列表接口返回的总数量
            bannerArr: [],
            isShow: false, // 弹窗默认不显示
            theRegionId: 0,
            theBrandId: 0,
            theDistanceId: 0,
            theDiscountId: '0',
            regionList: [],
            brandList: [],
            distanceList: [
                {
                    distanceName: '由近到远',
                    distanceId: 1
                },
                {
                    distanceName: '由远到近',
                    distanceId: 2
                }
            ],
            discountList: [
                {
                    discountName: '筛选',
                    discountId: '0'
                },
                {
                    discountName: '政府补贴优惠',
                    discountId: '1'
                },
                {
                    discountName: '满减',
                    discountId: '2'
                },
                {
                    discountName: '一口价',
                    discountId: '3'
                }
            ],
            toTopIsShow: false,
            // 城市筛选是否吸顶
            isCityTop: false,
            // 是否显示筛选弹框
            isShowLayer: false,
            currentSearchType: null,
            currentRegion: {
                regionName: '全城',
                regionId: 0
            }, // 当前区域
            currentBrand: {
                brandName: '品牌',
                brandId: 0
            }, // 当前品牌
            currentDistance: {
                distanceName: '由近到远',
                distanceId: 1
            }, // 当前距离
            currentDiscount: {
                discountName: '筛选',
                discountId: '0'
            },//当前筛选(默认没有选择)
            cityOffsetY: 0,
            openTip: false,
            govSubsidy: false, //是否是政府补贴 
            govSubsidyText: '',// 哈尔滨政府补贴筛选项文案，不同时间段不同
            govSubsidyTag: '', // 哈尔滨政府补贴筛选项Tag，不同时间段不同
        };
        this.goSearch = this.goSearch.bind(this);
        this.toTop = this.toTop.bind(this);
        this.goCity = this.goCity.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.closeFalseDialog = this.closeFalseDialog.bind(this);
        this.setCity = this.setCity.bind(this);
        this.refresh = this.refresh.bind(this);
        this.reloadMovie = this.reloadMovie.bind(this);
        this.wantSee = this.wantSee.bind(this);
        this._onHide = this._onHide.bind(this);
        this.getSetCity = this.getSetCity.bind(this);
        this.getHomePageCinemaCopy = this.getHomePageCinemaCopy.bind(this);
        this.pageLoading = false;
        this.isScrollEnabled = true;
        this.scrollViewHeight = 0;
    }

    _scroll;

    // 获取城市筛选位置
    layout(e) {
        const navBarHeight = this.navBarHeight;

        this.cityOffsetY = e.nativeEvent.layout.y - navBarHeight;
    }

    // 滚动到城市筛选位置
    scrollToCity = (type) => {
        const { cur_city } = this.props;
        const event_id = type === 'region' ? 'HomeAll' : (type === 'brand' ? 'HomeBrand' : 'HomeDistance');

        mta(event_id, 'Home', `${cur_city.cityName}`);

        const cityOffsetY = this.cityOffsetY;
        const _currentSearchType = this.state.currentSearchType;

        if (_currentSearchType === type) {
            this.setState({
                currentSearchType: type,
                isShowLayer: !this.state.isShowLayer
            }, () => {
                if (!this.state.isShowLayer) {
                    this.setState({
                        currentSearchType: null
                    });
                }
            });
        } else if (type) {
            this.setState({
                currentSearchType: type,
                isShowLayer: true
            });
        }

        if (!this.state.isCityTop) {
            this.setState({
                isCityTop: this.state.isCityTop
            }, () => {
                this.scrollToEl(0, cityOffsetY + 2);
            });
        }
    }

    // 滚动到城市筛选时，城市筛选吸顶
    topCitySearch = (e) => {
        const offsetY = e.nativeEvent.contentOffset.y;

        if (offsetY === this.cityOffsetY || offsetY > this.cityOffsetY) {
            if (this.state.isCityTop) return;
            this.setState({
                isCityTop: true
            });
        } else {
            this.setState({ isShowLayer: false, currentSearchType: null });
            this.setState({
                isCityTop: false
            });
        }
    }

    _getRef = (flatList) => {
        this._flatList = flatList;
        const reObj = this._flatList;

        return reObj;
    }

    onGroupBuyClick = (movieId) => {
        const { curType } = this.state;

        this.context.router.toMovieSchedule({
            movieId,
            scheduledType: curType
        });
    }

    onDetailClick=(movieId) => {
        const { curType } = this.state;

        this.context.router.toMovieDetail({ movieId, scheduledPlay: +curType === 3 ? 1 : null });
    }

    render() {
        const { curType, showType, loading, wifiOut, bannerArr, pageNum, totalNum, willMovieList, hotMovie, mostExpectList, cinemaList, dialog, lbsDialog, recity, isShow, aloading, test, toTopIsShow, scaleLoading } = this.state;
        const { lbs_city, cur_city } = this.props;
        const { isCityTop, isShowLayer, regionList, currentRegion, currentBrand, currentDistance, distanceList, brandList, currentSearchType, openTip, progress, navType, discountList, currentDiscount, govSubsidy, govSubsidyText, govSubsidyTag } = this.state;
        const { scheduledBannerUrl, scheduledBannerDetailUrl, scheduledMovieList, scheduledPageNum, scheduledTotalNum } = this.state;

        if (wifiOut) {
            return (
                <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1 } } />
            );
        }

        return (
            <View style={ { flex: 1 } }>
                <View style={ Platform.OS === 'ios' ? st.zIdex : null }>
                    {/* {/* {openTip && <Unreal
                        ref={ e => { this.refCouponList = e; } }
                        locationCode='ec8128c54e56468b948c2b5876f467c5'
                        locationCodeActivity='d80ff9a2b1414000bd46a9cfe6ada096'
                        channel='JDReactMovie'
                        mode='pro'
                    />} */}
                </View>
                <View style={ st.container }>

                    {/* <View style={{ flex: 1 }}> */}
                    <View style={ st.nav_wrap }>
                        <GradientNavBar
                            navBarProps={ {
                                leftButton: isWeb
                                    ? <View />
                                    : <JDTouchable onPress={ () => this.context.router.goBack() }>
                                        <JDImage source={ img.navBack } style={ st.nav_btn } />
                                    </JDTouchable>,
                                center:
                                    <View style={ st.center_wrap }>
                                        <JDImage source={ img.navCenter } style={ st.center_wrap_bg } />
                                        <JDTouchable
                                            onPress={ () => {
                                                mta('HomeCity', 'Home', `${cur_city.cityName}_${curType == 1 ? 'A' : 'B'}`);
                                                // 解决H5点击穿透问题，会点到下个页面输入框
                                                setTimeout(() => {
                                                    this.context.router.toCity();
                                                }, 100);
                                            } }
                                            contentContainerStyle={ { flexDirection: 'row', alignItems: 'center' } }
                                        >
                                            {!!recity && <JDText numberOfLines={ 1 } style={ st.center_pos }>{cur_city.cityName}</JDText>}
                                            {!recity && <JDText style={ st.center_pos } />}
                                            <JDImage source={ img.arrow_bottom } style={ st.center_more } />
                                        </JDTouchable>
                                        <JDTouchable style={ { flex: 1 } } onPress={ this.goSearch } contentContainerStyle={ { flexDirection: 'row', alignItems: 'center' } }>
                                            <JDImage source={ img.search } style={ st.center_search } />
                                            <JDText style={ st.center_search_placeholder }>找影院，电影</JDText>
                                        </JDTouchable>
                                    </View>,
                                rightButton: isWeb
                                    ? <View />
                                    : <JDTouchable onPress={ this.share }>
                                        <JDImage source={ img.navShare } style={ st.nav_btn } />
                                    </JDTouchable>
                            } }
                            progress={ progress }
                            navType={ navType }
                            onRefNavBar={ e => { this.refNavBar = e; } }
                            onRefGradientNavBar={ e => { this.onRefGradientNavBar = e; } }
                            onLayout={ (e) => {
                                this.navBarHeight = e.nativeEvent.layout.height;
                            } } />

                        {
                            (curType === 1 && isCityTop)
                                ? <CityScreening
                                    scrollToCity={ this.scrollToCity }
                                    currentRegion={ currentRegion }
                                    currentBrand={ currentBrand }
                                    currentDistance={ currentDistance }
                                    currentDiscount={ currentDiscount }
                                    govSubsidy={ govSubsidy }
                                    currentSearchType={ currentSearchType } />
                                : null
                        }
                        {
                            (curType === 1 && isCityTop && isShowLayer)
                                ? <DownLayer
                                    isShowResult={ isShowLayer }
                                    regionList={ regionList }
                                    brandList={ brandList }
                                    distanceList={ distanceList }
                                    discountList={ discountList }
                                    govSubsidyText={ govSubsidyText }
                                    govSubsidyTag={ govSubsidyTag }
                                    searchCinema={ this.selectedSearchItem }
                                    closeLayer={ () => { this.setState({ isShowLayer: false, currentSearchType: null }); } }
                                    currentRegion={ currentRegion }
                                    currentBrand={ currentBrand }
                                    currentDistance={ currentDistance }
                                    currentDiscount={ currentDiscount }
                                    currentSearchType={ currentSearchType } />
                                : null
                        }
                    </View>
                    {<ScrollView
                        showsVerticalScrollIndicator={ false }
                        contentContainerStyle={ st.index_wrap }
                        ref={ (scroll) => { this._scroll = scroll; } }
                        onScroll={ (e) => this._onScroll(e) }
                        scrollEventThrottle={ 16 }
                        style={ { flex: 1 } }
                        onContentSizeChange={ (width, height) => {
                            this.scrollViewHeight = height;
                        } }
                    >
                        <WebSwiper bannerArr={ bannerArr } />
                        {/* 最热，近期最受欢迎 */}
                        {
                            <View style={ [st.hot_wait, curType === 3 && { marginBottom: 0 }] }>
                                <View style={ st.check_type }>
                                    {
                                        showType.map((item, index) => {
                                            return (
                                                <TouchableOpacity
                                                    style={ [st.type_item, index === showType?.length - 1 ? st.type_item_last : {}] }
                                                    activeOpacity={ 0.5 }
                                                    key={ index }
                                                    onPress={ () => this.checkMovieType(item.type) }
                                                >
                                                    <View style={ st.type_wrap }>
                                                        <JDText style={ [st.type_text, (curType === item.type) && st.type_cur] }>{item.name}</JDText>
                                                        <JDText style={ [st.under_line, (curType === item.type) && st.under_line_cur] } />
                                                    </View>
                                                </TouchableOpacity>
                                            );
                                        })
                                    }
                                </View>
                                { curType === 3
                                    ? (
                                        <HotTopBook
                                            scheduledBannerUrl={ scheduledBannerUrl }
                                            scheduledBannerDetailUrl={ scheduledBannerDetailUrl }
                                        />
                                    )
                                    : (
                                        <HotTop hotMovie={ hotMovie } mostExpectList={ mostExpectList } movieType={ curType } />
                                    )
                                }
                            </View>
                        }
                        {/* 城市筛选 */}
                        {(curType === 1) &&
                            <View onLayout={ e => this.layout(e) }>
                                <CityScreening
                                    scrollToCity={ this.scrollToCity }
                                    onScroll={ (e) => this._onScroll(e) }
                                    currentRegion={ currentRegion }
                                    currentBrand={ currentBrand }
                                    currentDistance={ currentDistance }
                                    currentDiscount={ currentDiscount }
                                    govSubsidy={ govSubsidy }
                                    currentSearchType={ currentSearchType } />
                            </View>
                        }

                        {/* loading */}
                        {loading && <Loading contentStyle={ { marginTop: pt(230), marginBottom: pt(Dimensions.get('window').height - 300) } } />}
                        {/* 轮播图 热映、待映列表， 影院列表 */}
                        {/* -50-44-30 */}
                        {!loading && curType === 1 &&
                            // 150-statusBarHeight
                            <View style={ { minHeight: pt(Dimensions.get('window').height - 50 - 44) - iphoneXMarginBottom } }>
                                {!!cinemaList &&
                                    <FlatList
                                        keyExtractor={ (item, index) => index + '' }
                                        extraData={ this.state }
                                        data={ cinemaList }
                                        initialNumToRender={ 6 }
                                        renderItem={ ({ item, index }) => (<CinemaItem cinemaInfo={ item } number={ index + 1 } />) }
                                        ref={ this._getRef }
                                        ListEmptyComponent={ () => <SeeTomorrow contentText='暂无相关影院信息' /> }
                                    />
                                }
                            </View>
                            // </View>
                        }
                        {curType === 1 && !loading && pageNum <= totalNum &&
                            <LoadingAnimation />
                        }
                        {pageNum > totalNum && !loading && curType === 1 && !!cinemaList && cinemaList.length >= 20 &&
                            <View style={ { alignItems: 'center', justifyContent: 'center', paddingVertical: pt(10), backgroundColor: '#fff' } }>
                                <JDText>我是有底线的(^_^)</JDText>
                            </View>
                        }
                        {!loading && curType === 2 && willMovieList.length > 0 &&
                            <FlatList
                                data={ willMovieList }
                                keyExtractor={ (item, index) => index + '' }
                                initialNumToRender={ 3 }
                                renderItem={ ({ item }) => {
                                    if (item.isDate) {
                                        return (
                                            <JDText style={ st.pre_time }>
                                                {item.willTime}
                                                <JDText style={ st.pre_week }>{item.willWeek ? item.willWeek : '待定'}</JDText>
                                            </JDText>
                                        );
                                    } else {
                                        return <PreWantMovieItem cityId={ cur_city.cityId } wantSee={ this.wantSee } reloadMovie={ this.reloadMovie } movieInfo={ item } from='index' />;
                                    }
                                } }
                            />
                        }
                        {!loading && curType === 3 &&
                            <View style={ { minHeight: pt(Dimensions.get('window').height - 50 - 44) - iphoneXMarginBottom } }>
                                {!!cinemaList &&
                                    <FlatList
                                        scrollEnabled={ false }
                                        keyExtractor={ (item, index) => index + '' }
                                        style={ { backgroundColor: '#fff' } }
                                        // extraData={ this.state }
                                        // data={ cinemaList }
                                        data={ scheduledMovieList }
                                        initialNumToRender={ 6 }
                                        renderItem={ ({ item }) => (
                                            <BookShowItem
                                                { ...item }
                                                onGroupBuyClick={ this.onGroupBuyClick }
                                                onDetailClick={ this.onDetailClick }
                                            />
                                        ) }
                                        ref={ this._getRef }
                                        ListEmptyComponent={ () => (
                                            <SeeTomorrow
                                                contentText='啊哦~ 当前没有可预约放映的影片'
                                            />
                                        ) }
                                    />
                                }
                            </View>
                        }

                        {curType === 3 && !loading && scheduledPageNum <= scheduledTotalNum &&
                            <LoadingAnimation />
                        }
                        {scheduledPageNum > scheduledTotalNum && !loading && curType === 3 && !!scheduledMovieList && scheduledMovieList.length >= 20 &&
                            <View style={ { alignItems: 'center', justifyContent: 'center', paddingVertical: pt(10), backgroundColor: '#fff' } }>
                                <JDText>我是有底线的(^_^)</JDText>
                            </View>
                        }

                    </ScrollView>}
                    {/* 定位失败提示 */}
                    <JDConfirmDialog
                        show={ dialog }
                        onConfirm={ this.goCity }
                        onClose={ this.closeFalseDialog }
                        confirmText="选择城市"
                        cancelText="取消"
                    >
                        <View style={ st.dialog }><JDText style={ st.dialog_txt }>定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。</JDText></View>
                    </JDConfirmDialog>

                    {/* 切换为定位城市提示 */}
                    {!!lbs_city && <JDConfirmDialog
                        show={ lbsDialog }
                        onConfirm={ this.setCity }
                        onClose={ this.closeDialog }
                        confirmText="切换"
                        cancelText="取消"
                    >
                        <View style={ [st.dialog, { paddingBottom: pt(10) }] }>
                            <JDText style={ st.dialog_txt }>发现您正在{lbs_city.cityName}</JDText>
                        </View>
                        <View style={ { marginBottom: pt(20) } }>
                            <JDText style={ [st.dialog_txt, st.gray] }>是否切换?</JDText>
                        </View>
                    </JDConfirmDialog>}

                    {/* 返回顶部 */}
                    {toTopIsShow &&
                        <TouchableOpacity onPress={ this.toTop } style={ [st.to_top, { bottom: pt(100) + iphoneXMarginBottom }] }>
                            <JDImage style={ st.to_top_icon } source={ img.to_top } />
                        </TouchableOpacity>
                    }
                    {/* 今日特价 */}
                    {/* {test.length !== 0 &&
                        <TouchableOpacity
                            onPress={ () => {
                                mta('HomeTodayOnSale', 'Home', `${cur_city.cityName}`);
                                this.specialPrice();
                            } }
                            style={ [st.special_price, { bottom: pt(55) + iphoneXMarginBottom }] }
                        >
                            <JDImage source={ { uri: netImg.special_price } } style={ { width: '100%', height: '100%' } } />
                        </TouchableOpacity>
                    } */}
                    {/* 弹窗 今日特价 */}
                    <JDPopupWindow show={ isShow && test.length > 0 } onHide={ this._onHide } height={ (test.length === 1 && test[0].specialCinemaVOS.length === 1) ? pt(390) + iphoneXMarginBottom : pt(520) + iphoneXMarginBottom } >
                        {isShow && <View style={ [st.container1, { height: (test.length === 1 && test[0].specialCinemaVOS.length === 1) ? pt(390) + iphoneXMarginBottom : pt(520) + iphoneXMarginBottom }] }>
                            <SpecialPrice onHide={ this._onHide } aloading={ aloading } scaleLoading={ scaleLoading } cur_city={ cur_city } test={ test } />
                        </View>}
                    </JDPopupWindow>

                    {/* 开场提示 */}
                    <OpeningHint ref={ (hint) => { this._hint = hint; } } openTip={ this.openTip } />
                    {/* 底部导航栏 */}
                    <Nav addZindex={ isShow && test.length > 0 } />

                    <View style={ {
                        height: iphoneXMarginBottom,
                        backgroundColor: '#fff',
                        width: '100%',
                        zIndex: isShow && test.length > 0 ? 8 : 3
                    } } />
                </View>
            </View>
        );
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'nav_change',
            navCurIndex: 0
        });
        setTimeout(() => this.initCity(), 0);

        isNetWork().then(res => {
            if (res.type === 'none') {
                this.setState({ wifiOut: true });
            }
        });
        const movie_channel = getCookie('movie_channel');

        document.title = '京东电影';
        const { curType } = this.state;

        window.jdShare?.setShareInfo({
            title: curType === 1 ? '京东电影票 热映大片选座购票' : curType === 2 ? '京东电影票 新片预告片抢鲜看' : '京东电影票，经典影片预约放映观看',
            content: curType === 1 ? '看电影，上京东！看热映影片预告片，在线选座立即购票！' : curType === 2 ? '看电影，上京东！新片资讯预告片精彩不容错过！' : '预约放映，上京东！视听盛宴，精彩再现！',
            url: window.location.href,
            img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
            channel: '',
            callback: null
        });
        // 今日特价入口返回后解座
        // let selectedSeat =  fetchLocal('selectedSeat')?fetchLocal('selectedSeat'):false
        const planId = fetchLocal('planId');
        const selectedSeat = fetchLocal('selectedSeat');
	      const { scheduledPlay = '0' } = this.props;

        if (selectedSeat != null) {
            get('releaseSeat', {
                planId,
	            selectedSeat,
	            scheduledPlay: +scheduledPlay
            }).then((res) => { });
        };

        if(!planId || !selectedSeat || !(+scheduledPlay)){
            sgmReport('1001', {function_id: 'releaseSeat',message:`缺少参数planId:${planId}或selectedSeat:${selectedSeat}或scheduledPlay:${scheduledPlay}` }, 3)
        }
        localStorage.removeItem('selectedSeat');
    }

    componentDidFocus() {
        mtaPV('Home');

        const { cur_city } = this.props;

        // const { recity } = this.state;
        this.props.dispatch({
            type: 'change_label',
            label: 0
        });

        this.getTanData(cur_city.cityId);
        // 开场提示
        this._hint && this._hint.hintStorage();
        if (this.canLoad) {
            this.getMovieComingListVO(cur_city.cityId);
        }
    }

    componentDidUpdate(prev) {
        const { cur_city, lbs } = this.props;
        const { curType } = this.state;

        if (cur_city.cityId !== prev.cur_city.cityId && !!this.canLoad) {
            this._scroll.scrollTo({ x: 0, y: 0, animated: true });
            this.setState({
                isShowLayer: false,
                theRegionId: 0,
                theBrandId: 0,
                theDistanceId: 0,
                theDiscountId: '0',
                currentSearchType: null,
                currentRegion: {
                    regionName: '全城',
                    regionId: 0
                }, // 当前区域
                currentBrand: {
                    brandName: '品牌',
                    brandId: 0
                }, // 当前品牌
                currentDistance: {
                    distanceName: '由近到远',
                    distanceId: 1
                },
                currentDiscount: {
                    discountName: '筛选',
                    discountId: '0'
                }
            }, () => {
                this.getData(cur_city.cityId);
            });
        }

        if (!!lbs && !!lbs?.lon && !!this.canLoad && (lbs?.lon !== prev?.lbs?.lon || lbs?.lat !== prev?.lbs?.lat) && curType === 1) {
            this.getHomePageCinema(cur_city.cityId);
        } else if (!!lbs && !!lbs?.lon && !!this.canLoad && (lbs?.lon !== prev?.lbs?.lon || lbs?.lat !== prev?.lbs?.lat) && curType === 3) {
            this.scheduledMovieListFetch(cur_city.cityId);
        }
    }

    openTip = (Value) => {
        this.setState({ openTip: Value });
    }

    // 滚动到指定元素位置
    scrollToEl(layoutX, layoutY) {
        this._scroll.scrollTo({ x: layoutX, y: layoutY, animated: false });
    }

    getData(cityId) {
        this.getBanner();
        this.getHotList(cityId);
        this.getHomePageCinema(cityId);
        this.getMovieComingListVOByWeight(cityId);
        this.getMovieComingListVO(cityId);
        this.filterCinemas(cityId);
        this.getTanData(cityId);
        this.scheduledMovieListFetch(cityId);
    }

    getBanner() {
        get('getCmsInfoByPageType', { pageType: 1, adSource: 2 }).then(res => {
            const bannerArr = res.data.advertisementVOList ? res.data.advertisementVOList : [];

            this.setState({ bannerArr });

            const hasEmpty = bannerArr.some(item =>  !item.picUrl);
            if(hasEmpty){
                sgmReport('1002', {function_id: 'getCmsInfoByPageType',message:'数据未返回图片地址！'}, 3)
            }
        });
    }

    getHotList(cityId) {
        get('getMovieHotListVO', { cityId }).then((res) => {
            let hotMovie = res.data;

            if (!hotMovie) {
                hotMovie = [];
            }
            this.setState({ hotMovie, loading: false });
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'getMovieHotListVO',message:'缺少参数cityId'}, 3)
        }
    }

    getHomePageCinema = (cityId, pageNum = 1, pageSize = 20, queryDate = '') => {
        const { lbs } = this.props;
        const { theRegionId, theBrandId, theDistanceId, theDiscountId } = this.state;
        const data = {
            cityId,
            regionId: theRegionId,
            brandId: theBrandId,
            descDistance: theDistanceId !== 2,
            //筛选
            promoFilter: [theDiscountId],
            lon: 116.397477,
            lat: 39.908692,
            pageSize,
            pageNum,
            queryDate
        };

        if (!!lbs && !!lbs?.lon) {
            data.lon = lbs.lon;
            data.lat = lbs.lat;
        }

        get('homePageCinema', data).then(res => {
            let cinemaList = res?.data?.list;

            if (!cinemaList) { cinemaList = []; }
            const queryDate = res.data.queryDate;

            const totalNum = Math.ceil(res.data.totalCount / 20);

            pageNum += 1;
            this.setState({ cinemaList, pageNum, queryDate, totalNum, loading: false });

            if(cinemaList && cinemaList.length){
                const hasEmpty = cinemaList.some(item => !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'homePageCinema',message:'数据未返回图片地址！'}, 3)
                }
            }

        });

        if(!cityId || !theRegionId || !theBrandId){
            sgmReport('1001', {function_id: 'homePageCinema',message:'缺少参数cityId/regionId/brandId'}, 3)
        }
    }

    /**
     * 预约放映
     * @param {*} cityId
     */
    scheduledMovieListFetch = (cityId, scheduledPageNum = 1, scheduledPageSize = 20) => {
        get('scheduledMovieList', {
            cityId,
            pageNum: scheduledPageNum,
            pageSize: scheduledPageSize
        }, true).then((res) => {
            let scheduledMovieList = res?.data?.list;

            if (!scheduledMovieList) { scheduledMovieList = []; }

            const scheduledTotalNum = Math.ceil((res?.data?.totalCount || 0) / 20);

            scheduledPageNum += 1;
            this.setState({
                scheduledBannerUrl: res?.data?.bannerUrl || '',
                scheduledBannerDetailUrl: res?.data?.bannerDetailUrl || '',
                scheduledPageNum,
                scheduledTotalNum,
                scheduledMovieList,
                loading: false
            });
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'scheduledMovieList',message:'缺少参数cityId'}, 3)
        }
    }

    // 分页用于获取影院列表
    getHomePageCinemaCopy(cityId, pageNum = 1, pageSize = 20, queryDate = '') {
        const { lbs } = this.props;
        const { theRegionId, theBrandId, theDistanceId, theDiscountId } = this.state;
        const data = {
            cityId,
            regionId: theRegionId,
            brandId: theBrandId,
            descDistance: theDistanceId !== 2,
            //筛选
            promoFilter: [theDiscountId],
            lon: 116.397477,
            lat: 39.908692,
            pageSize,
            pageNum,
            queryDate
        };
        if (!!lbs && !!lbs?.lon) {
            data.lon = lbs.lon;
            data.lat = lbs.lat;
        }
        get('homePageCinema', data, true).then(res => {
            let cinemaList = res?.data?.list;
            if (!cinemaList) { cinemaList = []; }
            const queryDate = res.data.queryDate;

            const totalNum = Math.ceil((res?.data?.totalCount || 0) / 20);

            pageNum += 1;
            const cinemaListCopy = [...this.state.cinemaList];

            cinemaList = cinemaListCopy.concat(cinemaList);
            this.setState({ cinemaList, pageNum, queryDate, totalNum, loading: false });

            if(cinemaList && cinemaList.length){
                const hasEmpty = cinemaList.some(item => !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'homePageCinema',message:'数据未返回图片地址！'}, 3)
                }
            }
            setTimeout(() => {
                this.pageLoading = false;
            }, 500);
        }, () => {
            // this.setState({ wifiOut: true });
        }).catch(() => {
            // this.setState({ wifiOut: true });
        });

        if(!cityId || !theRegionId || !theBrandId){
            sgmReport('1001', {function_id: 'homePageCinema',message:'缺少参数cityId/regionId/brandId'}, 3)
        }
    }

    scheduledMovieListFetchCopy = (cityId, scheduledPageNum = 1, scheduledPageSize = 20) => {
        get('scheduledMovieList', {
            cityId,
            pageNum: scheduledPageNum,
            pageSize: scheduledPageSize
        }, true).then((res) => {
            let scheduledMovieList = res?.data?.list;

            if (!scheduledMovieList) { scheduledMovieList = []; }

            const scheduledTotalNum = Math.ceil(res.totalCount / 20);

            scheduledPageNum += 1;

            const scheduledMovieListCopy = [...this.state.scheduledMovieList];

            scheduledMovieList = scheduledMovieListCopy.concat(scheduledMovieList);
            setTimeout(() => {
                this.pageLoading = false;
            }, 500);
            this.setState({
                scheduledPageNum,
                scheduledTotalNum,
                scheduledMovieList,
                loading: false
            });
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'scheduledMovieList',message:'缺少参数cityId'}, 3)
        }
    }

    getMovieComingListVOByWeight(cityId) {
        get('getMovieComingListVOByWeight', { cityId }).then(res => {
            let mostExpectList = res.data;

            if (!mostExpectList) {
                mostExpectList = [];
            }
            this.setState({ mostExpectList });
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'getMovieComingListVOByWeight',message:'缺少参数cityId'}, 3)
        }
    }

    getMovieComingListVO(cityId) {
        get('getMovieComingListVO', { cityId }).then(res => {
            let willMovieList = res.data;

            if (!willMovieList) {
                willMovieList = [];
            }

            this.setState({ willMovieList });

            if(willMovieList && willMovieList.length){
                const hasEmpty = willMovieList.some(item =>  !item.isDate && !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getMovieComingListVO',message:'数据未返回图片地址！'}, 3)
                }
            }
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'getMovieComingListVO',message:'缺少参数cityId'}, 3)
        }
    }

    // 获取弹窗数据
    getTanData(cityId) {
        let { lbs } = this.props;

        if (!lbs && !lbs?.lon) {
            lbs = {};
            lbs.lon = 116.397477;
            lbs.lat = 39.908692;
        }
        this.setState({
            scaleLoading: false
        });
        get('getSpecialMoviesVO', { cityId: cityId, lon: lbs?.lon, lat: lbs?.lat }, false).then(res => {
            const test = res.data ? res.data : [];
            // let test = [];
            /* 埋点计算总数 start */

            global.movieNum = test.length;
            global.cinemaNum = 0;
            global.listNum = 0;
            test.forEach(val => {
                global.cinemaNum = global.cinemaNum + val.specialCinemaVOS.length;
                val.specialCinemaVOS.forEach(list => {
                    global.listNum = global.listNum + list.specialPlanVOS.length;
                });
            });

            /* 埋点计算总数 end */
            this.setState({
                test,
                scaleLoading: true
            });

            if(test && test.length){
                const hasEmpty = test.some(item => !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getSpecialMoviesVO',message:'数据未返回图片地址！'}, 3)
                }
            }
            
        }, () => {
        }).catch(() => {

        });

        if(!cityId){
            sgmReport('1001', {function_id: 'getSpecialMoviesVO',message:'缺少参数cityId'}, 3)
        }
    }

    // 想看回调
    wantSee() {
        const { cur_city } = this.props;

        this.getMovieComingListVO(cur_city.cityId);
        this._hint && this._hint.hintStorage();
        // this.setState({ loading: true });
    }

    _onScroll = (e) => {
        JDNativeSystem.clearImageCache();
        const offsetY = e.nativeEvent.contentOffset.y;

        let progress = offsetY / (pt(213) - this.navBarHeight);

        progress > 1 && (progress = 1);
        progress < 0 && (progress = 0);
        const navType = progress < 0.5 ? 0 : 1;

        navType !== this.state.navType && this.setState({ navType });
        this.state.progress.setValue(progress);
        this.onRefGradientNavBar.setOpacity(0.5 + Math.abs(progress - 0.5));

        const { curType, pageNum, pageSize, queryDate, totalNum, toTopIsShow } = this.state;
        const { scheduledPageNum, scheduledPageSize, scheduledTotalNum } = this.state;

        const pageLoading = this.pageLoading;

        const info = e.nativeEvent;
        // if (!this.height && this.state.curType === 1) {
        //     this.height = info.contentSize.height;
        // }
        // let height = this.height > info.contentSize.height ? this.height : info.contentSize.height;

        const scrollHeight = info.contentOffset.y;

        const screenHeight = info.layoutMeasurement.height;

        const height = this.scrollViewHeight;

        const { cur_city } = this.props;

        if (scrollHeight >= 2) {
            !toTopIsShow && this.setState({ toTopIsShow: true });
        } else {
            toTopIsShow && this.setState({ toTopIsShow: false });
        }
        if (curType === 3) { // 预约放映添加加载更多的逻辑
            if (scrollHeight + screenHeight + 40 > height && scheduledPageNum <= scheduledTotalNum && !pageLoading) {
                this.pageLoading = true;
                this.scheduledMovieListFetchCopy(cur_city.cityId, scheduledPageNum, scheduledPageSize);
            }

            return;
        }
        if (curType != 1) {
            return;
        }
        this.isScrollEnabled && this.topCitySearch(e);
        if (scrollHeight + screenHeight + 40 > height && pageNum <= totalNum && !pageLoading) {
            // tip(`正在加载第 ${pageNum} 页`);
            this.pageLoading = true;
            this.getHomePageCinemaCopy(cur_city.cityId, pageNum, pageSize, queryDate);
        }
    }

    // _onScroll = (e) => {
    //     // JDNativeSystem.clearImageCache();
    //     this.navBarRef?.onScroll(e);
    //     const { curType, pageNum, pageSize, queryDate, totalNum, toTopIsShow } = this.state;
    //     const pageLoading = this.pageLoading;
    //     const info = e.nativeEvent;
    //     // if (!this.height && this.state.curType === 1) {
    //     //     this.height = info.contentSize.height;
    //     // }
    //     // let height = this.height > info.contentSize.height ? this.height : info.contentSize.height;

    //     const scrollHeight = info.contentOffset.y;
    //     const screenHeight = info.layoutMeasurement.height;
    //     const height = this.scrollViewHeight;
    //     const { cur_city } = this.props;

    //     if (scrollHeight >= 2) {
    //         !toTopIsShow && this.setState({ toTopIsShow: true });
    //     } else {
    //         toTopIsShow && this.setState({ toTopIsShow: false });
    //     }
    //     if (curType !== 1) {
    //         return;
    //     }
    //     this.isScrollEnabled && this.topCitySearch(e);
    //     if (scrollHeight + screenHeight + 40 > height && pageNum <= totalNum && !pageLoading) {
    //         // tip(`正在加载第 ${pageNum} 页`);
    //         this.pageLoading = true;
    //         this.getHomePageCinemaCopy(cur_city.cityId, pageNum, pageSize, queryDate);
    //     }
    // }

    // 定位失败-选择城市
    goCity() {
        this.setState({
            dialog: false
        }, () => {
            this.context.router.toCity();
        });
    }

    //  定位失败 点击取消  关闭弹层
    closeFalseDialog() {
        this.setState({
            dialog: false,
            lbsDialog: false
        });
    }

    // 定位成功 点击‘取消’ 关闭弹层
    closeDialog() {
        this.setState({
            dialog: false,
            lbsDialog: false
        });
    }

    // 切换到定位城市
    setCity() {
        const { dispatch, lbsCity } = this.props;

        this._scroll.scrollTo({ x: 0, y: 0, animated: true });

        dispatch({
            type: 'cur_city',
            cur_city: lbsCity
        });

        storage.save({
            key: 'movieCityHistory',
            data: [lbsCity]
        });

        this.getData(lbsCity.cityId);

        this.setState({
            dialog: false,
            lbsDialog: false
        });
    }

    initCity() {
        this.getPosition().then(positionCityObj => {
            this.getSetCity(positionCityObj);
        }, () => {
            this.getSetCity();
        });
    }

    // 获取上一次访问的城市
    getSetCity(positionCityObj) {
        const { dispatch, cur_city } = this.props;

        // 与历史城市对比
        storage.load({
            key: 'movieCityHistory'
        }).then(hisres => {
            if (hisres) {
                // 有历史记录
                if (positionCityObj) {
                    // 定位成功且有历史记录
                    const hisCityId = hisres[0].cityId;

                    if (positionCityObj.cityId === hisCityId) {
                        //  如果定位城市和历史城市一致，直接展示定位城市
                        dispatch({
                            type: 'cur_city',
                            cur_city: hisres[0]
                        });
                        this.getData(hisres[0].cityId);
                    } else {
                        // 如果定位城市和历史城市不一致，展示历史城市，弹出切换城市弹层
                        dispatch({
                            type: 'cur_city',
                            cur_city: hisres[0]
                        });

                        this.getData(hisres[0].cityId);

                        setTimeout(() => {
                            const refreshed = fetchSession('refreshed') || false;

                            if (!refreshed) {
                                saveSession('refreshed', true);
                                this.setState({ lbsDialog: true });
                            }
                        }, 1000);
                    }
                } else {
                    // 定位失败且有历史记录
                    dispatch({
                        type: 'cur_city',
                        cur_city: hisres[0]
                    });

                    this.getData(hisres[0].cityId);
                }
            } else {
                // 无历史记录
                if (positionCityObj) {
                    // 定位成功且无历史记录，展示定位城市
                    dispatch({
                        type: 'cur_city',
                        cur_city: positionCityObj
                    });

                    this.getData(positionCityObj.cityId);
                    // 保存定位城市到历史
                    storage.save({
                        key: 'movieCityHistory',
                        data: [positionCityObj]
                    });
                } else {
                    // 定位失败且无历史记录，展示默认城市
                    this.getData(cur_city.cityId);
                }
            }

            this.setState({
                recity: true
            });
        }).catch(() => {
            // 获取历史城市失败同无历史记录处理
            if (positionCityObj) {
                // 定位成功且获取历史记录失败，展示定位城市
                dispatch({
                    type: 'cur_city',
                    cur_city: positionCityObj
                });
                this.getData(positionCityObj.cityId);
                // 保存定位城市到历史
                storage.save({
                    key: 'movieCityHistory',
                    data: [positionCityObj]
                });
            } else {
                // 定位失败且获取历史记录失败，展示默认城市
                this.getData(cur_city.cityId);
            }

            this.setState({
                recity: true
            });
        });
    }

    getPosition = async() => {
        const { dispatch, cur_city = {} } = this.props;
        try {
            console.log('🚀 准备开始定位', cur_city, LBSbusinessId, sceneId);
            // await withLocation();
            console.log('🚀 权限检测完成,即将获取位置');
            // const loc = await getWebLocation();
            const loc = await getLBS(LBSbusinessId, sceneId);
            const {
              lon = 116.397477,
              lat = 39.908692
            } = loc || {};
            console.log('🚀 定位结束', loc);
            console.warn(`lon-${lon},lat-${lat}`);
            const res = await get('getCityInfoByLocation', { lon, lat, ip: 'l' }, true);
            dispatch({
                type: 'lbs',
                lbs: { lon, lat }
            });
            dispatch({
                type: 'lbsCity',
                lbsCity: res.data
            });

            if(!lon || !lat){
                sgmReport('1001', {function_id: 'getCityInfoByLocation',message:'缺少参数lon/lat'}, 3)
            }

            return res.data;
        } catch (e) {
	          console.log('🚀 定位失败原因', e);
            if (cur_city?.auto_chose) {
                console.log('用户已经选了城市');
            } else {
                this.setState({ dialog: true });
                throw new Error('定位失败：您未允许京东获取定位权限，您可在系统设置中开启');
            }
        }
    }

    // 刷新页面
    refresh() {
        this.setState({ loading: true, wifiOut: false, isCityTop: false, currentSearchType: null, isShowLayer: false });
        this.initCity();
    }

    reloadMovie() {
        const { cur_city } = this.props;

        this.getMovieComingListVO(cur_city.cityId);
    }

    // tap栏切换
    checkMovieType(curType) {
        const nowType = this.state.curType;

        if (curType === nowType) {
            return;
        }
        // window.jdShare?.setShareInfo({
        //     title: curType === 1 ? '京东电影票 热映大片选座购票' : '京东电影票 新片预告片抢鲜看',
        //     content: curType === 1 ? '看电影，上京东！看热映影片预告片，在线选座立即购票！' : '看电影，上京东！新片资讯预告片精彩不容错过！',
        //     url: window.location.href,
        //     img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
        //     channel: '',
        //     callback: null
        // });
        mta(curType === 1 ? 'HomeHot' : 'HomeComing', 'Home');
        this.setState({ curType });
    }

    // 搜索页
    goSearch() {
        const { cur_city } = this.props;
        const { curType } = this.state;

        mta('HomeSearch', 'Home', `${cur_city.cityName}_${curType === 1 ? 'A' : 'B'}`);
        localStorage.removeItem('keyWord');
        this.context.router.toSearch();
    }

    // 返回顶部
    toTop() {
        this._scroll.scrollTo({ x: 0, y: 0, animated: true });
    }

    // 今日特价
    specialPrice() {
        const { cur_city } = this.props;

        this.getTanData(cur_city.cityId);

        this.isCityTop = this.state.isCityTop;
        this.isScrollEnabled = false;
        this.setState({
            isCityTop: this.isCityTop ? false : this.isCityTop,
            isShow: true
        });
        mta('SpecPopExpo', 'Home', `${cur_city.cityName}`);
    }

    /* 关闭弹层 */
    _onHide() {
        const { isShow, aloading } = this.state;

        const { cur_city } = this.props;

        // 城市名称_推荐影片数量_推荐影院数量_场次数量
        if (isShow) {
            mta('SpecPopClose', 'Home', `${cur_city.cityId}_${global.movieNum}_${global.cinemaNum}_${global.listNum}`);
        }
        this.isScrollEnabled = true;

        this.setState({
            isShow: false,
            aloading: true,
            isCityTop: this.isCityTop
        });
    }

    // 获取区域和品牌
    filterCinemas = cityId => {
        // const cityId = this.props.cur_city.cityId;
        const indexFlag = true;

        get('filterCinemas', { cityId, indexFlag }).then(res => {
            console.log("filterCinemas", res)
            this.setState({
                regionList: res.data.region,
                brandList: res.data.brand,
                govSubsidy: res.data.govSubsidy === 'true',
                govSubsidyText: res.data.govSubsidyText,
                govSubsidyTag: res.data.govSubsidyTag
            });
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'filterCinemas',message:'缺少参数cityId'}, 3)
        }
    }

    // 选择查询条件
    selectedSearchItem = (item) => {
        const { cur_city } = this.props;
        const { currentSearchType, currentRegion } = this.state;

        if (currentSearchType === 'region') {
            mta('HomeAllItem', 'Home', `${cur_city.cityName}_${item.regionName}_${item.cinemaCount}`);
        } else if (currentSearchType === 'brand') {
            mta('HomeBrandItem', 'Home', `${cur_city.cityName}_${currentRegion.regionName}_${item.brandName}_${item.cinemaCount}`);
        } else if (currentSearchType === 'distance') {
            mta('HomeDistanItem', 'Home', `${item.distanceName}`);
        } else if (currentSearchType === 'discount') {//筛选条件

        }

        this.setState({ loading: true, cinemaList: [] });
        const { loading } = this.state;

        if (!loading) {
            if (currentSearchType === 'region') {
                this.setState({ theRegionId: item.regionId, currentRegion: item }, () => {
                    this.scrollToEl(0, this.cityOffsetY + 2);
                    this.getHomePageCinema(cur_city.cityId);
                });
            } else if (currentSearchType === 'brand') {
                this.setState({ theBrandId: item.brandId, currentBrand: item }, () => {
                    this.scrollToEl(0, this.cityOffsetY + 2);
                    this.getHomePageCinema(cur_city.cityId);
                });
            } else if (currentSearchType === 'distance') {
                this.setState({ theDistanceId: item.distanceId, currentDistance: item }, () => {
                    this.scrollToEl(0, this.cityOffsetY + 2);
                    this.getHomePageCinema(cur_city.cityId);
                });
            } else if (currentSearchType === 'discount') {//筛选条件
                this.setState({ theDiscountId: item.discountId, currentDiscount: item }, () => {
                    this.scrollToEl(0, this.cityOffsetY + 2);
                    this.getHomePageCinema(cur_city.cityId);
                });
            }
        }
    }

    componentWillUnfocus() {
        this.canLoad = true;
    }
}

Index.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const { lbsCity, cur_city, label, lbs } = state.index;

    return {
        lbsCity,
        cur_city,
        label,
        lbs
    };
};

export default connect(select, null, null, { withRef: true })(Index);